import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';

/**
 * Generated class for the EditdrivergradePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editdrivergrade',
  templateUrl: 'editdrivergrade.html',
})
export class EditdrivergradePage {
  _id = ''
  Title = ''
  obj: any;
  cb: any
  _idx = -1

  _gSpeed = null
  _gRpm = null
  _gIdle = null

  _gSpeedTf = false;
  _gRpmTf = false;
  _gIdleTf = false;

  //_coeffArr = ['0.05', '0.1', '0.15', '0.2', '0.25', '0.3', '0.35', '0.4', '0.45', '0.5']

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController) {
    this.obj = navParams.get('gradeD')
    this._gSpeed = this.obj.gradespeedlimit
    this._gRpm = this.obj.graderpmlimit
    this._gIdle = this.obj.gradeidleminuteslimit
    this._id = this.obj.id
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditporttypesPage');

    if (this._gSpeed != -1 && this._gSpeed != null) this._gSpeedTf = true;
    if (this._gRpm != -1 && this._gRpm != null) this._gRpmTf = true;
    if (this._gIdle != -1 && this._gIdle != null) this._gIdleTf = true;
  }

  changeParameter(_what) {
    if (_what == 'speed') {
      if (!this._gSpeedTf) {
        this._gSpeed = -1
      } else {
        if (this._gSpeed == -1) this._gSpeed = null
      }
    }
    if (_what == 'rpm') {
      if (!this._gRpmTf) {
        this._gRpm = -1
      } else {
        if (this._gRpm == -1) this._gRpm = null
      }
    }
    if (_what == 'idle') {
      if (!this._gIdleTf) {
        this._gIdle = -1
      } else {
        if (this._gIdle == -1) this._gIdle = null
      }
    }
  }
  editDriverGrade() {
    var _that = this
    if (!this._gSpeedTf) {
      this._gSpeed = -1
    } else {
      if (this._gSpeed == null || this._gSpeed == '') {
        let toast = _that.toastCtrl.create({
          message: this.dic.l["enterS"] + '!',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        return false;
      }
    }
    if (!this._gRpmTf) {
      this._gRpm = -1
    } else {
      if (this._gRpm == null || this._gRpm == '') {
        let toast = _that.toastCtrl.create({
          message: this.dic.l["enterR"] + '!',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        return false;
      }
    }
    if (!this._gIdleTf) {
      this._gIdle = -1
    } else {
      if (this._gIdle == null || this._gIdle == '') {
        let toast = _that.toastCtrl.create({
          message: this.dic.l["enterI"] + '!',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        return false;
      }
    }

    var _dat = {
      id: this.gn.crypt(this._id),
      gspeed: this.gn.crypt(this._gSpeed),
      grpm: this.gn.crypt(this._gRpm),
      gidle: this.gn.crypt(this._gIdle),
    }
    var _that = this
    this.gn._Post('/api/gn/savegradeveh', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb(_that._gSpeed, _that._gRpm, _that._gIdle)
      }
      let toast = _that.toastCtrl.create({
        message: _that.dic.l["succS"] + '!',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }


}





// WEBPACK FOOTER //
// ./src/pages/settings/vehiclesettinngs/editdrivergrade/editdrivergrade.ts